"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments(host, port) {
    return ['REPLICAOF', host, port.toString()];
}
exports.transformArguments = transformArguments;
